<template>
	<el-descriptions style="margin-top: 20px;margin-bottom: 20px;" size="mini" class="margin-top" title="申请信息" border>
		<el-descriptions-item v-if="biao.type">
			<template slot="label">
				<i class="el-icon-paperclip"></i>
				家庭经济状况
			</template>
			{{biao.type}}
		</el-descriptions-item>
		<el-descriptions-item v-if="biao.edu">
			<template slot="label">
				受教育情况
			</template>
			{{biao.edu}}
		</el-descriptions-item>
	<el-descriptions-item v-if="biao.yixiang">
		<template slot="label">
			意向职位
		</template>
		{{biao.yixiang}}
	</el-descriptions-item>
	<el-descriptions-item v-if="biao.geren">
		<template slot="label">
			个人状况
		</template>
		{{biao.geren}}
	</el-descriptions-item>
	</el-descriptions>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		computed:{
			
		},
		watch:{
			biao(){
			  	
			}
		},
		props:["biao"],
		created() {
			
		}
	}
</script>

<style>
</style>
